'use client'

import * as React from 'react'

import * as DialogPrimitive from '@radix-ui/react-dialog'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer'
import { useIsMd } from '@/hooks'
import { CommonX } from '@/icons'

interface BaseProps {
  children: React.ReactNode
}

interface RootCredenzaProps extends BaseProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

interface CredenzaProps extends BaseProps {
  className?: string
  asChild?: true
}

export const Credenza = ({ children, ...props }: RootCredenzaProps) => {
  const isDesktop = useIsMd()
  const Credenza = isDesktop ? Dialog : Drawer

  return <Credenza {...props}>{children}</Credenza>
}

export const CredenzaContent = React.forwardRef<
  React.ElementRef<typeof DialogContent | typeof DrawerContent>,
  React.ComponentPropsWithoutRef<typeof DialogContent | typeof DrawerContent> & {
    showDefaultCloseButton?: boolean
  }
>(({ className, children, showDefaultCloseButton = true, ...props }, ref) => {
  const isDesktop = useIsMd()
  const CredenzaContent = isDesktop ? DialogContent : DrawerContent

  return (
    <CredenzaContent ref={ref as any} className={`${className}`} aria-describedby={undefined} {...props}>
      {children}
      {showDefaultCloseButton && (
        <DialogPrimitive.Close className='absolute right-6 top-6 rounded-sm ring-[1px] md:ring-[0.5px] [@media(max-resolution:1.9dppx)]:ring-[1px] ring-white-10 hover:ring-white-100 transition-all duration-300 w-8 h-8 flex items-center justify-center group'>
          <CommonX className='size-5 md:size-6' />
        </DialogPrimitive.Close>
      )}
    </CredenzaContent>
  )
})

export const CredenzaTitle = ({ className, children, ...props }: CredenzaProps) => {
  const isDesktop = useIsMd()
  const CredenzaTitle = isDesktop ? DialogTitle : DrawerTitle

  return (
    <CredenzaTitle className={className} {...props}>
      {children}
    </CredenzaTitle>
  )
}
